import { ready } from 'core-utilities';
import React from 'react';
import { render } from 'react-dom';
import App from './App';
import { rootElementId } from './app.config';
import '../../../css/idVerificationWithVendor/idVerificationWithVendor.scss';

ready(() => {
  if (document.getElementById(rootElementId)) {
    render(<App />, document.getElementById(rootElementId));
  }
});
